import React from "react";
import { connect } from "react-redux";
import { Form } from "react-advanced-form";
import { Input, Button } from "react-advanced-form-addons";
import TypeAheadInput from "./../../form/TypeAheadInput";
import rules from "./validation-rules";
import messages from "./validation-messages";
import ImageUploader from "react-images-upload";
import { loadShapers } from "./../../../actions/shaper";
import { loadBoards } from "./../../../actions/board";
import { matchSuggestions } from "./../../../lib/utils/suggest";

const mapStateToProps = (state) => {
	return {
		session: state.session,
		boards: state.boards.data,
		shapers: state.shapers.data,
	};
};

const mapDispachToProps = (dispatch) => {
	return {
		loadShapers: (session, params) => dispatch(loadShapers(session, params)),
		loadBoards: (session, params) => dispatch(loadBoards(session, params)),
	};
};

const relations = {
	shapers: ["Board"],
	boards: ["Manufacturer"],
};

class UserBoardForm extends React.Component {
	constructor() {
		super();
		this.state = {
			board_id: null,
			manufacturer_id: null,
		};
	}

	onChange = (propertyName, newValue) => {
		const data = [];
		data[propertyName] = newValue;
		this.setState({
			...data,
		});
	};

	componentDidMount() {
		if (this.props.session.isLoggedIn) {
			if (!this.props.boards.length)
				this.props.loadBoards(this.props.session, {
					limit: 1000,
					withs: relations.boards,
				});
			if (!this.props.shapers.length)
				this.props.loadShapers(this.props.session, {
					limit: 1000,
					withs: relations.shapers,
				});
		} else {
			this.props.history.push("/");
		}
	}

	// onBlur writes the raw text when it matches nothing, so the selected shaper
	// is not always the number the catalog rows carry.
	boardsForShaper = () => {
		const shaperId = Number(this.state.manufacturer_id);
		return this.props.boards.filter(
			(entity) => Number(entity.manufacturer_id) === shaperId
		);
	};

	getBoardSuggestions = (value) =>
		matchSuggestions(this.boardsForShaper(), "model", value);

	getShaperSuggestions = (value) =>
		matchSuggestions(this.props.shapers, "name", value);

	render() {
		return (
			<div className="container">
				<Form
					action={({ serialized, fields, form }) =>
						this.props.processFormSubmission({
							session: this.props.session,
							serialized,
							fields,
							form,
						})
					}
					rules={rules}
					messages={messages}
				>
					<div className="row">
						<div className="col-12 ">
							<TypeAheadInput
								entity={this.props.shapers}
								name="manufacturer_id"
								keyName="name"
								label="choose a shaper"
								className="form-control"
								placeholder="Unknown"
								value={this.state.manufacturer_id}
								setValue={this.onChange}
								getSuggestions={this.getShaperSuggestions}
								display={true}
								required
							/>
							<TypeAheadInput
								entity={this.props.boards}
								name="board_id"
								keyName="model"
								label="choose a model"
								className="form-control"
								placeholder="choose a board"
								value={this.state.board_id}
								setValue={this.onChange}
								getSuggestions={this.getBoardSuggestions}
								display={this.state.manufacturer_id !== null}
								required
							/>
							<Input
								name="name"
								label="Nickname (optional)"
								className="form-control"
								placeholder="Defaults to shaper + model"
							/>
							<div className="gw-field">
								<label className="gw-field-label">Photos</label>
								<div className="gw-uploader gw-uploader-drop">
									<ImageUploader
										withIcon={false}
										buttonText="Choose images"
										onChange={this.props.onDrop}
										imgExtension={[".jpg", ".jpeg", ".png", ".gif"]}
										/* the library's default label hardcodes its own extension
										   list, so it keeps saying jpg|gif|png unless it is
										   passed in */
										label="Max file size: 5mb, accepted: jpg|jpeg|png|gif"
										maxFileSize={5242880}
										withPreview={true}
									/>
								</div>
							</div>
						</div>
						<div className="col-12">
							<Input
								type="hidden"
								name="user_id"
								value={this.props.session.user.id}
							/>
							<Button type="submit">
								{this.props.edit ? "Edit Board" : "Add Board"}
							</Button>
						</div>
					</div>
				</Form>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispachToProps)(UserBoardForm);
